<app-schedule-toolbar></app-schedule-toolbar>
<!--bodyWidth: {{s.smallPeriodHolderWidth()}}
scrollPos: {{s.scrollPosition()}}-->
<div class="selected-date-controls">
  <mat-form-field class="view-selector" appearance="outline">
    <mat-label>View</mat-label>
    <mat-select (selectionChange)="periodChanged($event)" [value]="s.selectedPeriod().period">
      @for (view of s.periodViews; track view) {
      <mat-option [value]="view.id">{{view.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  
  <div class="date-navigation">
    <button mat-icon-button color="accent" (click)="navigateBackward()" [title]="'Previous ' + s.selectedPeriod().largePeriod">
      <mat-icon color="tertiary">keyboard_arrow_left</mat-icon>
    </button>
    
    <mat-form-field class="date-picker" appearance="outline">
      <mat-label>Select Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="onDateChange($event.value)">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <button mat-icon-button color="accent" (click)="navigateForward()" [title]="'Next ' + s.selectedPeriod().largePeriod">
      <mat-icon color="tertiary">keyboard_arrow_right</mat-icon>
    </button>
  </div>
</div>

<div class="scheduler-full">
  <div class="scheduler-header">
    <div class="elements-spacer"></div>
    <div class="header-holder">
      <app-scheduler-header></app-scheduler-header>
    </div>
  </div>

  <div class="scheduler-body">
    <div class="elements-holder">
      @if (data.schedules && data.schedules.length > 0){
      <mat-action-list>
        @for (schedule of data.schedules; track schedule) {
          <mat-list-item class="schedule-row" (click)="scheduleClick(schedule)">
            <mat-icon matListItemIcon>account_circle</mat-icon>
            <div matListItemTitle>{{schedule.name}}</div>
          </mat-list-item>
        }
      </mat-action-list>
      }
    </div>
    <div class="body-holder" #scrollSync>
      @if (data.schedules && data.schedules.length > 0 && data.appointments && data.appointments.length > 0){

      @switch (s.selectedPeriod().id) {

      @case ('day') {
      <div class="small-period-holder scroller" [class]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <div class="period-small-box"></div>
        }
      </div>
      }

      @case ('workDay') {
      <div class="small-period-holder scroller" [class]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <div class="period-small-box"></div>
        }
      </div>
      }

      @case ('week') {
      <div class="small-period-holder scroller" [class]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <div class="period-small-box"></div>
        }
      </div>
      }

      @case ('2week'){
      <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <div class="period-small-box"></div>
        }
      </div>
      }

      @case ('month'){
      <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <div class="period-small-box"></div>
        }
      </div>
      }

      @case ('year'){
      <div class="small-period-holder scroller" [ngClass]="s.selectedPeriod().period" [style.width.px]="getContentWidth()">
        @for (period of s.rangesInPeriod(); track $index){
        <!--<div class="period-small-box">{{period.startOf(s.selectedPeriod().smallPeriod).month}}/{{period.startOf(s.selectedPeriod().smallPeriod).day}} - {{period.endOf(s.selectedPeriod().smallPeriod).month}}/{{period.endOf(s.selectedPeriod().smallPeriod).day}}</div>-->
        <div class="period-small-box"></div>
        }
      </div>
      }

      @default {
      Default case.
      }

      }
      <!-- end switch -->
      @for (schedule of data.schedules; track schedule) {
      <div class="entry-holder" [style.width.px]="data.scrollSyncWidth()">
        @if (shouldUseGroupedView()) {
          @for (groupedAppt of getGroupedAppointments(schedule.id); track groupedAppt.id) {
          <app-appointment-entry 
            [style]="groupedAppt.style"
            [appointment]="groupedAppt" 
            [selectedPeriod]="s.selectedPeriod()" 
            [schedule]="schedule">
          </app-appointment-entry>
          }
        } @else {
          @for (appt of data.appointments; track appt){
          @if (appt.scheduleId && appt.scheduleId == schedule.id){
          <app-appointment-entry 
            [style]="appt.style"
            [appointment]="appt" 
            [selectedPeriod]="s.selectedPeriod()" 
            [schedule]="schedule">
          </app-appointment-entry>
          }
          }
        }
      </div>
      }

      }
      <!-- end if -->
      @else {
      <div class="no-entries">no schedule or no appointments</div>
      }
    </div>
  </div>

  <div class="scheduler-footer">
    <div class="footer-holder">

    </div>
  </div>
</div>